export default __webpack_public_path__ + "static/media/arrowLeft.83aa775a.svg";